import type { AlbumFont } from '../types';

const LINK_ID = 'gromly-album-fonts';

/**
 * ADR-0048: the album's typefaces load only when an album is open — never on
 * the landing or in the main CSS. One stylesheet for every cut of the
 * catalogue (ADR-0053), so switching a pair or a box's font doesn't wait on the network.
 */
export function ensureAlbumFonts(fonts: AlbumFont[]): void {
  if (typeof document === 'undefined' || document.getElementById(LINK_ID)) return;
  const byFamily = new Map<string, Set<string>>();
  for (const font of fonts) {
    const axes = byFamily.get(font.family) ?? new Set<string>();
    axes.add(`${font.italic ? 1 : 0},${font.weight}`);
    byFamily.set(font.family, axes);
  }
  const families = [...byFamily.entries()].map(([family, axes]) => {
    const list = [...axes].sort();
    const anyItalic = list.some(a => a.startsWith('1'));
    const spec = anyItalic ? `ital,wght@${list.join(';')}` : `wght@${list.map(a => a.split(',')[1]).join(';')}`;
    return `family=${family.replace(/ /g, '+')}:${spec}`;
  });
  const link = document.createElement('link');
  link.id = LINK_ID;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?${families.join('&')}&display=swap`;
  document.head.appendChild(link);
}

export function fontCss(font: AlbumFont): { fontFamily: string; fontWeight: number; fontStyle: 'italic' | 'normal' } {
  return { fontFamily: `'${font.family}', Georgia, serif`, fontWeight: font.weight, fontStyle: font.italic ? 'italic' : 'normal' };
}
